import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getFaqRecentsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/faq/recent");

  return response.data;
};
